import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { DataGrid, GridColDef, GridRowParams, GridRowsProp } from "@mui/x-data-grid";
import { useContext, useState } from "react";
import { bhpButtonSx } from "../../styles/bhpStyles";
import { Dashboard } from "../../enums/Dashboard";
import VspPortalContext from "../../store/VspPortalContext";
import dateFormat from "dateformat";


const dataGridSx = {

    cursor: 'pointer',
    '.MuiDataGrid-columnHeaderTitle': { 
        fontWeight: 'bold !important',
        overflow: 'visible !important'
    }

};


type DashboardEventsLatestProps = {

    columns: GridColDef[ ];
    dashboard: Dashboard;
    isChildLoading: boolean;
    isParentLoading: boolean;
    rows: GridRowsProp;
    selectRow ( rowId: string ): void ;
    sortField: string;
    style: React.CSSProperties;

};


export const DashboardEventsLatest : React.FC< DashboardEventsLatestProps > = ( props : DashboardEventsLatestProps ) => {

    const { columns, dashboard, isChildLoading, isParentLoading, rows, selectRow, sortField, style } = props;

    const [ pageSize, setPageSize ] = useState<number>( 10 );

    const { state } = useContext( VspPortalContext );

    
    const genericExport = ( ) => {

        const titleKeys = Object.keys( rows[0] );
        const formattedRows = [ ];
        formattedRows.push( titleKeys );

        rows.forEach( row => formattedRows.push( Object.values( row ) ) );

        let csvContent = "data:text/csv;charset=utf-8," + formattedRows.map( e => e.join( "," ) ).join( "\n" );

        const encodedUri = encodeURI( csvContent );
        const link = document.createElement( "a" );
        link.setAttribute( "href", encodedUri );
        link.setAttribute( "download", "data.csv" );
        document.body.appendChild( link );
        link.click( );

    };


    const specificExport = ( fileName: string, keys: { [ name: string ]: string } ) => {
       
        let csvContent = "data:text/csv;charset=utf-8,";
        
        Object.values( keys ).forEach( value => csvContent+=value + "," );

        csvContent+="\n";

        rows.forEach( row => {

            Object.keys( keys ).forEach( key => csvContent+=row[key] + "," );
            csvContent+="\n";

        });

        

        const encodedUri = encodeURI( csvContent );
        const link = document.createElement( "a" );
        link.setAttribute( "href", encodedUri );
        link.setAttribute( "download", fileName );
        document.body.appendChild( link );
        link.click( );

    };

    
    const handleExportClick = ( ) => {

        const dateTime = dateFormat( new Date( ), 'yymmddHHMss' );
        const fileName = `DoorBattExport_${state.village}_${dateTime}`;

        let keys: { [ name: string ]: string } = { };
        
        switch( dashboard ) {

            case Dashboard.BatteryLevel:

                keys.doorName = 'Door Name';
                keys.eventDateTime = 'Event Date Time';
                keys.voltage = 'Voltage Group';
                
                specificExport( fileName, keys );
                
                break;

            default:
                genericExport( );

        }

    };

    
    return (
        <>
            {
                isParentLoading
                    ?
                <Box
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                >
                    <CircularProgress size={ 40 } sx={{ color: '#e65400' }}/>
                </Box>
                    :
                <>

                    {

                        rows.length > 0
                            &&
                        
                        <Stack direction="column" display="flex" alignItems="center" gap={ 0.5 } sx={{ marginTop: '50px' }}>

                            <DataGrid
                                onRowClick={ ( params: GridRowParams, _, __ ) => selectRow( params.row.id )  }
                                sx={[ dataGridSx, style ]}
                                rows={rows}
                                columns={columns}
                                disableSelectionOnClick
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[ 10, 20, 50, 100 ]}
                                pagination
                                autoHeight={true}
                                loading={isChildLoading}
                                initialState={{
                                    sorting: {
                                      sortModel: [{ field: sortField, sort: 'asc' }],
                                    }
                                }}
                            />

                            <Button onClick={ handleExportClick } sx={{ ...bhpButtonSx, marginTop: '10px', width: '250px' }} disabled={ false }>
                                Export
                            </Button>

                        </Stack>

                    }

                </>
            }
        </>

    );

};